import React from 'react';
import { Percent } from 'lucide-react';
import { tierFor } from '../services/stock';
import { useT } from '../services/i18n';

// Product page: quantity discount table, highlights the tier matching the chosen quantity
const PriceTiers = ({ product, quantity }) => {
  const { t } = useT();
  const tiers = [...(product.tiers || [])].sort((a, b) => a.min_qty - b.min_qty);
  if (!tiers.length) return null;
  const active = tierFor(product, quantity);
  const rows = [{ min_qty: 1, discount_pct: 0 }, ...tiers];
  return (
    <div className="mt-6" data-testid="price-tiers">
      <p className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2"><Percent size={16} className="text-orange-500" /> {t('tiers.title')}</p>
      <div className="border rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
            <tr>
              <th className="px-3 py-2 text-left">{t('tiers.quantity')}</th>
              <th className="px-3 py-2 text-right">{t('tiers.unitPrice')}</th>
              <th className="px-3 py-2 text-right">{t('tiers.saving')}</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {rows.map((tier, idx) => {
              const next = rows[idx + 1];
              const isActive = tier.discount_pct === 0 ? !active : active?.min_qty === tier.min_qty;
              const unit = product.price * (1 - tier.discount_pct / 100);
              return (
                <tr key={tier.min_qty} data-testid={`tier-row-${tier.min_qty}`} className={isActive ? 'bg-orange-50 font-semibold' : ''}>
                  <td className="px-3 py-2 text-gray-800">{next ? t('tiers.range', { a: tier.min_qty, b: next.min_qty - 1 }) : tier.min_qty === 1 ? '1' : t('tiers.andMore', { a: tier.min_qty })}</td>
                  <td className="px-3 py-2 text-right text-gray-900" data-testid={`tier-unit-price-${tier.min_qty}`}>{unit.toFixed(2)} €</td>
                  <td className="px-3 py-2 text-right">{tier.discount_pct ? <span className="text-green-700">−{tier.discount_pct}%</span> : <span className="text-gray-400">—</span>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="text-[11px] text-gray-500 mt-1">{t('tiers.note')}</p>
    </div>
  );
};

export default PriceTiers;
